import Benefit from "../Benefit";
import { Properties } from "../../../infrastructure/function-properties-types";

export default class BenefitBag {
  [key: string]: any;

  id: string;

  name: string;

  periodicity: number;

  date: Date;

  amount: string | number;

  canBeAccumulated: boolean;

  shouldBeDeliveredOnCardOnPeriodEnd: boolean;

  availableFor: {
    meal: Benefit;
    transport: Benefit;
    education: Benefit;
    nursery: Benefit;
    "health-insurance": Benefit;
    unknown: Benefit;
    "life-insurance": Benefit;
    "retirement-insurance": Benefit;
    "pension-plan": Benefit;
    "gift-card": Benefit;
    groceries: Benefit;
    gas: Benefit;
  };

  constructor({
    id = "",
    name = "",
    periodicity = 12,
    date = new Date(),
    amount = "0.00",
    canBeAccumulated = true,
    shouldBeDeliveredOnCardOnPeriodEnd = false,
    availableFor = {
      meal: new Benefit({
        name: "meal",
        config: {
          allowBalanceAccumulation: false,
          weekdaysAvailability: [
            {
              active: true,
              start: new Date(1970, 0, 1, 0, 0, 0),
              end: new Date(1970, 0, 1, 23, 59, 0),
            },
            {
              active: true,
              start: new Date(1970, 0, 1, 0, 0, 0),
              end: new Date(1970, 0, 1, 23, 59, 0),
            },
            {
              active: true,
              start: new Date(1970, 0, 1, 0, 0, 0),
              end: new Date(1970, 0, 1, 23, 59, 0),
            },
            {
              active: true,
              start: new Date(1970, 0, 1, 0, 0, 0),
              end: new Date(1970, 0, 1, 23, 59, 0),
            },
            {
              active: true,
              start: new Date(1970, 0, 1, 0, 0, 0),
              end: new Date(1970, 0, 1, 23, 59, 0),
            },
            {
              active: true,
              start: new Date(1970, 0, 1, 0, 0, 0),
              end: new Date(1970, 0, 1, 23, 59, 0),
            },
            {
              active: true,
              start: new Date(1970, 0, 1, 0, 0, 0),
              end: new Date(1970, 0, 1, 23, 59, 0),
            },
          ],
          dailyLimit: 0,
        },
      }),
      transport: new Benefit({
        name: "transport",
        config: {
          allowBalanceAccumulation: false,
        },
      }),
      education: new Benefit({ name: "education" }),
      renting: new Benefit({ name: "renting" }),
      nursery: new Benefit({ name: "nursery" }),
      "health-insurance": new Benefit({
        name: "health-insurance",
        config: [],
      }),
      wellness: new Benefit({ name: "wellness" }),
      unknown: new Benefit({ name: "unknown" }),
      "life-insurance": new Benefit({ name: "life-insurance" }),
      "retirement-insurance": new Benefit({ name: "retirement-insurance" }),
      "pension-plan": new Benefit({ name: "pension-plan" }),
      "gift-card": new Benefit({ name: "gift-card" }),
      "it-product": new Benefit({ name: "it-product" }),
      groceries: new Benefit({ name: "groceries" }),
      gas: new Benefit({ name: "gas" }),
    },
  }: Properties<BenefitBag>) {
    this.id = id;
    this.name = name;
    this.periodicity = periodicity;
    this.date = date;
    this.amount = amount;
    this.canBeAccumulated = canBeAccumulated;
    this.shouldBeDeliveredOnCardOnPeriodEnd =
      shouldBeDeliveredOnCardOnPeriodEnd;
    this.availableFor = availableFor;
  }
}
